import './MatchingTool.css';
import { useState, useEffect } from "react";
import { neon } from '@netlify/neon';
import Dialog from "../components/dialogBox";
import { Link, useSearchParams } from 'react-router-dom';
import ProductFilter from "../components/productFilter";

const sql = neon(import.meta.env.VITE_NETLIFY_DATABASE_URL);

const Product = ({user_id}) => {
    console.log("product_user_id: ", user_id)
    const [searchParams, setSearchParams] = useSearchParams();
  const [data, setData] = useState<Product[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [showDialog, setShowDialog] = useState(false);
  const [filter, setFilter] = useState<string>('all');

 const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');

  const showAlert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setShowDialog(true);
  };

  const [productFormData, setProductFormData] = useState({
    brandName: searchParams.get('brandname') ? searchParams.get('brandname') : '',
    sku: searchParams.get('sku') ? searchParams.get('sku') : '',
    styleName: searchParams.get('stylename') ? searchParams.get('stylename') : '',
    color: searchParams.get('color') ? searchParams.get('color') : '',
    gender: searchParams.get('gender') ? searchParams.get('gender') : '',
    category: searchParams.get('selector') == 'under' ? 'over' : 'under',
    units: searchParams.get('units') ? searchParams.get('units') : ''
  });
  const [errors, setErrors] = useState({
    brandName: '',
    sku: '',
    styleName: '',
    color: '',
    gender: '',
    units: ''
  });
  const validate = () => {
    const newErrors: typeof errors = {
      brandName: '',
      sku: '',
      styleName: '',
      color: '',
      gender: '',
      units: ''
    };
    if (!productFormData.brandName) newErrors.brandName = 'Brand Name is required';
    if (!productFormData.sku) newErrors.brandName = 'SKU is required';
    if (!productFormData.styleName) newErrors.styleName = 'Style Name is required';
    if (!productFormData.gender) newErrors.gender = 'Gender is required';
    if (!productFormData.units) newErrors.units = 'Units are required';
    setErrors(newErrors);
  return Object.values(newErrors).every(error => error === '');
  };

const sendEmailIfTrue = async (subject,message,to,cc) => {

  await fetch("/.netlify/functions/send-email", {
    method: "POST",
    body: JSON.stringify({
      shouldSend: true,
      subject: subject,
      message: message,
      to: to,
      cc: cc,
    }),
  });
};
const getUserEmail = async (user_id) => {

    const checkResult = await sql`
      SELECT * FROM issby_user
      WHERE id = ${user_id}`;

      return checkResult[0].email;
};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProductFormData({ ...productFormData, [name]: value });
  };
const checkMatch = async (formData: any) => {
  try {
    const { brandName, styleName, styleNumber,color, units, gender, user_id, category } = formData;

		if(category === 'Under') {
    const checkResult = await sql`
      SELECT * FROM issby_product
      WHERE brand_name = ${brandName}
      AND style_name = ${styleName}
      AND style_number = ${styleNumber}
      AND under_over_units >= ${units}
    `;
    if (checkResult.length > 0) {
      // Notify the user that a similar product exists
      // alert('A match is found');
	    showAlert('A match is Found','Your information is submitted successfully')

    } else {
	    showAlert('A match is not Found','Your information is submitted successfully')
  }
		}
		else {
    const checkResult = await sql`
      SELECT * FROM issby_product
      WHERE brand_name = ${brandName}
      AND style_name = ${styleName}
      AND style_number = ${styleNumber}
      AND under_over_units <= ${units}
    `;
    console.log("result", checkResult);
    if (checkResult.length > 0) {
      // Notify the user that a similar product exists
      // alert('A match is found');
	    showAlert('A match is Found','Your information is submitted successfully')
	    const user_email = getUserEmail(user_id)
	    sendEmailIfTrue('Issby: Match is found', `Your item with: ${brandName} ${styleName} ${styleNumber} ${units} found a match. Your vendor will be notified with your contact details. Thank you. Truly ISSBY`, `${user_email}`, 'priyathamsaichand@gmail.com')
    } else {
	    showAlert('A match is not Found','Your information is submitted successfully')
  }
		}

  }catch (error) {
    setError("Error fetching data: " + error);
    console.error("Error in productData:", error); // Debug statement
    alert('Error inserting data.');
  }
};

  const insertProductData = async (formData: any) => {
  try {
    const result = await sql`
      INSERT INTO issby_product (
        brand_name,sku, style_name, style_number, color, under_over, under_over_units,gender, user_id, creation_time
      ) VALUES (
        ${formData.brandName},${formData.sku}, ${formData.styleName}, ${formData.styleNumber}, ${formData.color}, ${formData.category},${formData.units}, ${formData.gender}, ${user_id}, CURRENT_TIMESTAMP) RETURNING id;
    `;
    console.log('Data inserted successfully:', result[0].id);
  } catch (error) {
    console.error('Error inserting data:', error);
  }
};
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (validate()) {
      try {
	await checkMatch(productFormData);
        await insertProductData(productFormData);
        setShowDialog(true);
      } catch (error) {
        console.error('Error submitting data:', error);
      }
    }
  };

  interface Product {
    brandName: string;
    styleName: string;
    sku: string;
    styleNumber: string;
    color: string;
    gender: string;
    category: string;
    underOverUnits: number;
    creationTime: string;
  }

  const productData = async () => {
    try {
      const result = await sql`SELECT * FROM issby_product;`;
      const products = result.map((row: any) => ({
        brandName: row.brand_name,
        styleName: row.style_name,
        sku: row.sku,
        styleNumber: row.style_number,
        color: row.color,
        gender: row.gender,
        category: row.under_over, // Assuming 'under_over' is the category
        underOverUnits: row.under_over_units,
        creationTime: new Date(row.creation_time).toLocaleString()
      }));
      console.log("Mapped products:", products); // Debug statement
      setData(products);
    } catch (error) {
      setError("Error fetching data: " + error);
      console.error("Error in productData:", error); // Debug statement
    }
  };

  useEffect(() => {
    productData();
  }, [data]);

const renderTable = (products: Product[], filter: string) => {
  const filteredProducts = products.filter((product) => {
    const creationDate = new Date(product.creationTime);
    const currentDate = new Date();
    const diffInTime = currentDate.getTime() - creationDate.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    if (filter === 'today') {
      return diffInDays === 0;
    } else if (filter === 'any day before') {
      return diffInDays > 0;
    }
    return true;
  });

  return (
    <div style={{ marginBottom: '20px' }}>
      <select value={filter} onChange={(e) => setFilter(e.target.value)}>
        <option value="all">All</option>
        <option value="today">Today</option>
        <option value="any day before">Any day before</option>
      </select>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Creation time</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Brand Name</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Style Name</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>SKU</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Color</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>M/F/Kids</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Under/Over</th>
            <th style={{ border: '1px solid #ccc', padding: '8px', textAlign: 'left' }}>Total number of units</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((product, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.creationTime}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.brandName}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.sku}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.styleName}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.styleNumber}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.color}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.gender}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.category}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{product.underOverUnits}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


  return (
    <div className="container">
    <h1>The Matching Tool</h1>
      <section className="overview-section">
      <p>
When your listed SKU is the same as another retailer’s listing (regardless of the order submitted), <b>but the opposite type</b>, a digital match results. It is immediately emailed to the "matched" retailer, with instructions to contact each other directly by phone. The cost to relocate dislocated merchandise typically follows the vendor's price list, but it's not required.
      </p>
      <p>
        The fee for our service is $5 per month. Not to worry, our revenue will increase as retailers realize the value. As more retailers place listings, the chance of matches increases. Please consider: a network with only, say, 100 retailers offers the chance of matching with 99 others.
      </p>
      <p>Ho hum.</p>
      <p>
        Once independent footwear retailers realize that ISSBY offers its service to <b>thousands of independent footwear retailers</b>, the potential for matches with other retailers will be "<em>thousands minus one</em>". When one acknowledges that every store is over in this and under in that, it should be clear that FEDEX and UPS will be busy.
      </p>
</section>
<form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '-4em' }}>
  <hr style={{ margin: '20px 0', border: 'none'}} />
  <table className='matching-table'>
    <thead>
      <tr>
        <th scope="col" >Brand Name </th>
        <th  scope="col">Style Name</th>
        <th  scope="col">SKU</th>
        <th  scope="col">Color</th>
        <th  scope="col">Gender</th>
        <th># OF PAIRS</th>
        <th>Under or Over</th>
        <th>Submit</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <input
            type="text"
            name="brandName"
            placeholder={searchParams.get('brandname') ? searchParams.get('brandname') : 'ADIDAS'}
            value={productFormData.brandName}
            onChange={handleChange}
            style={{fontSize:'1em', width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td >
          <input
            type="text"
            name="styleName"
            placeholder={searchParams.get('stylename') ? searchParams.get('stylename') : 'Stan Smith'}
            value={productFormData.styleName}
            onChange={handleChange}
            style={{ fontSize:'1em',width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td >
          <input
            type="text"
            name="sku"
            placeholder={searchParams.get('sku') ? searchParams.get('sku') : 'ABCDE12345'}
            value={productFormData.sku}
            onChange={handleChange}
            style={{ fontSize:'1em',width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td >
          <input
            type="text"
            name="color"
            placeholder={searchParams.get('color') ? searchParams.get('color') : 'White'}
            value={productFormData.color}
            onChange={handleChange}
            style={{ fontSize:'1em',width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td >
          <input
            type="text"
            name="gender"
            placeholder={searchParams.get('gender') ? searchParams.get('gender') : 'Men'}
            value={productFormData.sku}
            onChange={handleChange}
            style={{ fontSize:'1em',width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td>
          <input
            type="text"
            name="units"
            placeholder={searchParams.get('units') ? searchParams.get('units') : '10'}
            value={productFormData.units}
            style={{ fontSize:'1em', width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
          />
        </td>
        <td >
          <select
            name="category"
            style={{ fontSize:'1em',width: '80%', padding: '8px', border: '1px solid black', borderRadius: '4px', color: 'black' }}
            value={searchParams.get('selector') ? searchParams.get('selector'): "defaulter"}
          >
            <option value="defaulter">Select...</option>
            <option value="under" >Under</option>
            <option value="over">Over</option>
          </select>
        </td>
        <td >
          <button type="submit" style={{ padding: '5px 5px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
            Submit
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</form>
<div style={{display: 'flex', justifyContent: 'center'}}>
<h2 style={{marginLeft: '10px'}} className="shimmer">Innovative Retail</h2>
</div>
      {/*
      {error && <p style={{ color: 'red' }}>{error}</p>}
 <ProductFilter products={data} onFilterChange={(filter) => {
        console.log('Filter changed to:', filter);
      }} />
       */}
      {showDialog && (
 <Dialog
        titler={alertTitle}
        message={alertMessage}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
      />
      )}
        <Link to="/matched" style={{ textDecoration: 'none', color: '#000', margin: '80%' }}>
        <button type="submit" style={{ padding: '10px 20px', border: 'none', backgroundColor: '#007BFF', color: '#fff', borderRadius: '4px', cursor: 'pointer' }}>
        Proceed to next page
        </button>
</Link>
      <div style={{display: 'flex', justifyContent: 'center', gap: '20em'}}>
      <h4 style={{marginLeft: '2em'}}>Page 3 of 3</h4>
      </div>
    </div>
  );
};

export default Product;
